import { instance } from 'api/core';

export interface AssignLocationToStationDto {
    locationId: string;
}

export const assignLocationToStation = async (
    stationId: string,
    dto: AssignLocationToStationDto,
    callback: { success: () => void; error?: (err: any) => void }
) => {
    try {
        await instance.patch(`/asrs/stations/${stationId}/assign-location`, dto);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};